import axios from 'axios';

const api = axios.create({
  baseURL: 'http://8.131.87.39:8080',  // API 基础地址
  timeout: 10000,  // 请求超时设置
});

// 获取法规URL
export const fetchLawUrl = async (data) => {
  try {
    const url = '/law/getLawUrlByMap';
    const headers = {
      'Content-Type': 'application/json',
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error('请求失败:', error);
    throw error;  // 抛出错误，供调用者捕获
  }
};

// 通过文件名返回法规内容及相关法规
export const fetchLawDetails = async (data) => {
  try {
    const url = '/law/getLawMapByMap';
    const headers = {
      'Content-Type': 'application/json',
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error('请求失败:', error);
    throw error;  // 抛出错误，供调用者捕获
  }
};

// 通过文件名返回法规url和微课
export const fetchVke = async (data) => {
  try {
    const url = '/law/getLawUrlMapByMap';
    const headers = {
      'Content-Type': 'application/json',
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error('请求失败:', error);
    throw error;  // 抛出错误，供调用者捕获
  }
};

// 客户提问和回答及IP记录
export const fetchSetLog = async (data) => {
  try {
    const url = '/law/setAiLogMap';
    const headers = {
      'Content-Type': 'application/json',
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result.data;
  } catch (error) {
    console.error('请求失败:', error);
    throw error;  // 抛出错误，供调用者捕获
  }
};

// 客户反馈意见发邮件
export const fetchSendEmail = async (data) => {
  try {
    const url = '/law/setAiFeedbackMap';
    const headers = {
      'Content-Type': 'application/json',
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('请求失败:', error);
    throw error;  // 抛出错误，供调用者捕获
  }
};



